import { axiosClassic, axiosWithAuth } from '../api/interceprots'
import { setAuthCookies } from '../api/tokens'

/** Сценарий C из бэкенд-гайда — вход на сайте через Telegram, подтверждение числом в боте. */
export interface TelegramLoginRequest {
	code: string
	poll_token: string
	confirm_number: number
	bot_deep_link: string
	expires_in: number
}

export type TelegramLoginPollResult =
	| { status: 'pending' }
	| { status: 'expired' }
	| {
			status: 'confirmed'
			access_token: string
			refresh_token: string
			user_id: string | number
			email: string | null
			expires_in?: number
	  }

export interface TelegramAuthTokens {
	token_type: 'Bearer'
	expires_in: number
	access_token: string
	refresh_token: string
	user_id: string | number
	email: string | null
}

export const TelegramAuthService = {
	/**
	 * Сценарий A (Mini App) — §3 бэкенд-гайда. init_data — сырая строка
	 * window.Telegram.WebApp.initData целиком, не парсить/не пересобирать:
	 * подпись считается по строке целиком, любое изменение → 401. Живёт 5
	 * минут после запуска Mini App — звать сразу при открытии.
	 */
	async initDataLogin(initData: string, inviteCode?: string) {
		const response = await axiosClassic.post<TelegramAuthTokens>('auth/telegram', {
			init_data: initData,
			invite_code: inviteCode,
		})
		setAuthCookies(response.data)
		return response.data
	},
	/**
	 * authenticated=false — обычный вход/регистрация. authenticated=true —
	 * привязка Telegram к уже залогиненному аккаунту.
	 *
	 * bind обязателен явно: axios шлёт withCredentials, и httpOnly-кука crm_at
	 * уезжает на бэкенд даже через axiosClassic. Без флага бэкенд считал
	 * привязкой любой вход при живой куке — а её фронт не видит и при логауте
	 * не чистит (clearAuthCookies трогает только js-cookie).
	 */
	async loginRequest(authenticated = false) {
		const client = authenticated ? axiosWithAuth : axiosClassic
		const response = await client.post<TelegramLoginRequest>(
			'auth/telegram/login-request',
			{ bind: authenticated }
		)
		return response.data
	},
	async loginPoll(pollToken: string) {
		const response = await axiosClassic.post<TelegramLoginPollResult>(
			'auth/telegram/login-poll',
			{ poll_token: pollToken }
		)
		// Ответ одноразовый (второй poll с тем же poll_token вернёт expired) —
		// куки ставим сразу, как только увидели confirmed.
		if (response.data.status === 'confirmed') {
			setAuthCookies(response.data)
		}
		return response.data
	},
}
